const rawPayments = String(import.meta.env.VITE_PAYMENTS_ENABLED ?? '').trim().toLowerCase();

/** Payments stay off unless a build explicitly turns them on. */
export const PAYMENTS_ENABLED = rawPayments === 'true';
